import {
  GET_TEAMS,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_FAIL,
  ADD_TEAMS,
  ADD_TEAMS_SUCCESS,
  ADD_TEAMS_FAIL,
  UPDATE_TEAMS,
  UPDATE_TEAMS_SUCCESS,
  UPDATE_TEAMS_FAIL,
  DELETE_TEAMS,
  DELETE_TEAMS_SUCCESS,
  DELETE_TEAMS_FAIL,
  SET_TEAM_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  teams: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const teamReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEAMS:
      return { ...state, loading: true }
    case GET_TEAMS_SUCCESS:
      return { ...state, loading: false, teams: action.payload }
    case GET_TEAMS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_TEAMS:
      return { ...state, loading: true }
    case ADD_TEAMS_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} }
    case ADD_TEAMS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_TEAMS:
      return { ...state, loading: true }
    case UPDATE_TEAMS_SUCCESS:
      return { ...state, loading: false, fieldErrors: {} }
    case UPDATE_TEAMS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_TEAMS:
      return { ...state, loading: true }
    case DELETE_TEAMS_SUCCESS:
      return { ...state, loading: false }
    case DELETE_TEAMS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_TEAM_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default teamReducer
